import React, { memo } from 'react'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { IShipmentBid } from 'types'
import { formatPerMile, formatCurrency } from 'utils/formatCurrency'

interface IRateProps {
  totalMiles: string
  targetRate: string
  userBids?: IShipmentBid[]
}

export const useBidStyles = makeStyles(() => ({
  bidCount: {
    color: brandColors.info,
    fontWeight: 600,
  },
}))

export const Rate = memo<IRateProps>(({ totalMiles, targetRate, userBids = [] }) => {
  const formattedMiles = parseFloat(totalMiles)
  const classes = useBidStyles()

  const BidAmount = () => {
    const bidCount = userBids.length
    if (bidCount === 0) {
      return <span>${formatPerMile(targetRate, formattedMiles, true)}/mi</span>
    }
    if (bidCount === 1) {
      const firstBid = userBids[0]
      const { amount: bidAmount } = firstBid || {}
      return (
        <Typography variant='body2' className={classes.bidCount} component='span'>
          {formatCurrency(bidAmount)} bid
        </Typography>
      )
    }
    return (
      <Typography variant='body2' className={classes.bidCount} component='span'>
        You placed {bidCount} bids
      </Typography>
    )
  }

  return (
    <>
      <div className='flex items-center'>
        <Typography variant='subtitle1' component='span'>
          {formatCurrency(targetRate)}
        </Typography>
      </div>
      <BidAmount />
    </>
  )
})
